import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Auth & UX
import LoginWrapper from "./components/Auth/LoginWrapper";
import PhoenixSignup from "./components/Auth/PhoenixSignup";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import SessionManager from "./components/Auth/SessionManager";
import Splash from "./components/Splash/Splash";

// Admin Components
import AdminHomeImages from "./components/AdminHomeImages";
import AdminJoinLink from "./components/AdminJoinLink";
import AdminAboutChapter from "./components/AdminAboutChapter";
import AdminAnnouncements from "./components/AdminAnnouncements";
import SingleAnnouncement from "./components/SingleAnnouncement";
import AdminTeam from "./components/AdminTeam";
import AdminBlogs from "./components/AdminBlogs";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import AdminEvents from "./components/AdminEvents";
import AdminOurTeam from "./components/AdminOurTeam";
import AdminGallery from "./components/AdminGallery";
import AdminBenefits from "./components/AdminBenefits";
import AdminCalendar from "./components/AdminCalendar";
import AdminPopup from "./components/AdminPopup";
import AdminPhone from "./components/AdminPhone";
import Developer from "./components/Developer/Developer";

import "./App.css";

// Admin Dashboard Layout (scrollable root)
const AdminDashboardLayout = () => (
  <div className="admin-dashboard-layout">
    <section id="home" className="admin-section">
      <AdminHomeImages />
    </section>

    <section id="joinlink" className="admin-section">
      <AdminJoinLink />
    </section>

    <section id="aboutchapter" className="admin-section">
      <AdminAboutChapter />
    </section>

    <section id="announcements-dashboard" className="admin-section">
      <AdminAnnouncements />
    </section>

    <section id="team" className="admin-section">
      <AdminTeam />
    </section>

    <section id="phone-management" className="admin-section">
      <AdminPhone />
    </section>
  </div>
);

function App() {
  return (
    <Splash>
      <Router>
        <SessionManager />
        <Header />
        <Routes>
          {/* PUBLIC */}
          <Route path="/login" element={<LoginWrapper />} />
          <Route path="/signup" element={<PhoenixSignup />} />

          {/* PROTECTED */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminDashboardLayout />
              </ProtectedRoute>
            }
          />

          <Route
            path="/blogs"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <AdminBlogs />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/events"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <AdminEvents />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ourteam"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <AdminOurTeam />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/team"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <AdminTeam />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/gallery"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <AdminGallery />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/benefits"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <AdminBenefits />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <AdminCalendar />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/popup"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <AdminPopup />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/announcements/:id"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <SingleAnnouncement />
                </div>
              </ProtectedRoute>
            }
          />
          <Route
            path="/developer"
            element={
              <ProtectedRoute>
                <div className="admin-page-section">
                  <Developer />
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
      </Router>
    </Splash>
  );
}

export default App;